import {
  createFileRoute,
  lazyRouteComponent,
  redirect,
} from '@tanstack/react-router';

export const Route = createFileRoute(
  '/(client)/questionnaires/(pages)/(list)/my-questionnaires',
)({
  beforeLoad: ({ location }) => {
    if (
      location.pathname === '/questionnaires/my-questionnaires' ||
      location.pathname === '/questionnaires/my-questionnaires/'
    ) {
      throw redirect({
        to: '/questionnaires/my-questionnaires/active',
      });
    }
  },
  component: lazyRouteComponent(
    () => import('../../../-components/MyQuestionnairesLayout'),
    'MyQuestionnairesLayout',
  ),
});
